module.exports = "/_next/static/images/8949f1cbba067905c8f0cb4fb8eb97b0-clips@mobile320.jpg";